import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ExitingPersistence, FadeIn, mediumDurationMs } from '@atlaskit/motion';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';

var LoadingItems = function LoadingItems(_ref) {
  var children = _ref.children,
      isLoading = _ref.isLoading,
      fallback = _ref.fallback,
      testId = _ref.testId;

  var _useShouldNestedEleme = useShouldNestedElementRender(),
      shouldRender = _useShouldNestedEleme.shouldRender;

  if (!shouldRender) {
    return children;
  }

  return jsx(ExitingPersistence, null, jsx(FadeIn, {
    key: "loading-section-".concat(isLoading),
    duration: mediumDurationMs
  }, function (motion, state) {
    return jsx("span", _extends({}, motion, {
      "data-testid": testId && "".concat(testId, "--").concat(state),
      css: {
        // Used to have the exiting section appear above the entering one.
        position: state === 'entering' ? undefined : 'absolute',
        zIndex: state === 'entering' ? 2 : 1,
        top: 0,
        left: 0,
        right: 0
      }
    }), isLoading ? fallback : children);
  }));
};

export default LoadingItems;